/**
 * Payment Service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { AirtimeCostReportDto } from '../model/airtimeCostReportDto';
// @ts-ignore
import { AirtimeCostReportDtoNotPersisted } from '../model/airtimeCostReportDtoNotPersisted';
// @ts-ignore
import { AirtimeFeesDoubleDto } from '../model/airtimeFeesDoubleDto';
// @ts-ignore
import { AirtimeProviderCsvCompareResultDto } from '../model/airtimeProviderCsvCompareResultDto';
// @ts-ignore
import { CreatedAirtimeCostReportDto } from '../model/createdAirtimeCostReportDto';
// @ts-ignore
import { TaskId } from '../model/taskId';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class AirtimeCostReportAPIService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @param id 
     * @param airtimeFeesDoubleDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changeActualFees(id: number, airtimeFeesDoubleDto: AirtimeFeesDoubleDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public changeActualFees(id: number, airtimeFeesDoubleDto: AirtimeFeesDoubleDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public changeActualFees(id: number, airtimeFeesDoubleDto: AirtimeFeesDoubleDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public changeActualFees(id: number, airtimeFeesDoubleDto: AirtimeFeesDoubleDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling changeActualFees.');
        }
        if (airtimeFeesDoubleDto === null || airtimeFeesDoubleDto === undefined) {
            throw new Error('Required parameter airtimeFeesDoubleDto was null or undefined when calling changeActualFees.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/airtime-cost-report/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/change-actual-fees`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: airtimeFeesDoubleDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param file 
     * @param report 
     * @param comProvider 
     * @param threshold 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public compareProviderCsv(file: Blob, report: CreatedAirtimeCostReportDto, comProvider?: 'GROUND_CONTROL' | 'MET_OCEAN' | 'GLOBALSTAR' | 'ORBCOMM' | 'IRIDIUM_JAPAN', threshold?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AirtimeProviderCsvCompareResultDto>;
    public compareProviderCsv(file: Blob, report: CreatedAirtimeCostReportDto, comProvider?: 'GROUND_CONTROL' | 'MET_OCEAN' | 'GLOBALSTAR' | 'ORBCOMM' | 'IRIDIUM_JAPAN', threshold?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AirtimeProviderCsvCompareResultDto>>;
    public compareProviderCsv(file: Blob, report: CreatedAirtimeCostReportDto, comProvider?: 'GROUND_CONTROL' | 'MET_OCEAN' | 'GLOBALSTAR' | 'ORBCOMM' | 'IRIDIUM_JAPAN', threshold?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AirtimeProviderCsvCompareResultDto>>;
    public compareProviderCsv(file: Blob, report: CreatedAirtimeCostReportDto, comProvider?: 'GROUND_CONTROL' | 'MET_OCEAN' | 'GLOBALSTAR' | 'ORBCOMM' | 'IRIDIUM_JAPAN', threshold?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (file === null || file === undefined) {
            throw new Error('Required parameter file was null or undefined when calling compareProviderCsv.');
        }
        if (report === null || report === undefined) {
            throw new Error('Required parameter report was null or undefined when calling compareProviderCsv.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>comProvider, 'comProvider');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>threshold, 'threshold');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        localVarUseForm = canConsumeForm;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (file !== undefined) {
            localVarFormParams = localVarFormParams.append('file', <any>file) as any || localVarFormParams;
        }
        if (report !== undefined) {
            localVarFormParams = localVarFormParams.append('report', localVarUseForm ? new Blob([JSON.stringify(report)], {type: 'application/json'}) : <any>report) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/airtime-cost-report/compare-provider-csv`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AirtimeProviderCsvCompareResultDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param airtimeCostReportDtoNotPersisted 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public confirmAirtimeCostReport(airtimeCostReportDtoNotPersisted: AirtimeCostReportDtoNotPersisted, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TaskId>;
    public confirmAirtimeCostReport(airtimeCostReportDtoNotPersisted: AirtimeCostReportDtoNotPersisted, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskId>>;
    public confirmAirtimeCostReport(airtimeCostReportDtoNotPersisted: AirtimeCostReportDtoNotPersisted, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskId>>;
    public confirmAirtimeCostReport(airtimeCostReportDtoNotPersisted: AirtimeCostReportDtoNotPersisted, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (airtimeCostReportDtoNotPersisted === null || airtimeCostReportDtoNotPersisted === undefined) {
            throw new Error('Required parameter airtimeCostReportDtoNotPersisted was null or undefined when calling confirmAirtimeCostReport.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/airtime-cost-report/confirm`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TaskId>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: airtimeCostReportDtoNotPersisted,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param comType 
     * @param year 
     * @param month 
     * @param actualActivationFee1 
     * @param actualMonthlyFee1 
     * @param actualDataFee1 
     * @param actualActivationFee2 
     * @param actualMonthlyFee2 
     * @param actualDataFee2 
     * @param comProvider1 
     * @param comProvider2 
     * @param skipIridiumDeviceStatusCheck 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createNewAirtimeCostReport(comType: 'IRIDIUM' | 'GLOBALSTAR' | 'NB_IOT' | 'NO_COMMUNICATION' | 'GSM', year: number, month: 'JANUARY' | 'FEBRUARY' | 'MARCH' | 'APRIL' | 'MAY' | 'JUNE' | 'JULY' | 'AUGUST' | 'SEPTEMBER' | 'OCTOBER' | 'NOVEMBER' | 'DECEMBER', actualActivationFee1: number, actualMonthlyFee1: number, actualDataFee1: number, actualActivationFee2?: number, actualMonthlyFee2?: number, actualDataFee2?: number, comProvider1?: 'GROUND_CONTROL' | 'MET_OCEAN' | 'GLOBALSTAR' | 'ORBCOMM' | 'IRIDIUM_JAPAN', comProvider2?: 'GROUND_CONTROL' | 'MET_OCEAN' | 'GLOBALSTAR' | 'ORBCOMM' | 'IRIDIUM_JAPAN', skipIridiumDeviceStatusCheck?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TaskId>;
    public createNewAirtimeCostReport(comType: 'IRIDIUM' | 'GLOBALSTAR' | 'NB_IOT' | 'NO_COMMUNICATION' | 'GSM', year: number, month: 'JANUARY' | 'FEBRUARY' | 'MARCH' | 'APRIL' | 'MAY' | 'JUNE' | 'JULY' | 'AUGUST' | 'SEPTEMBER' | 'OCTOBER' | 'NOVEMBER' | 'DECEMBER', actualActivationFee1: number, actualMonthlyFee1: number, actualDataFee1: number, actualActivationFee2?: number, actualMonthlyFee2?: number, actualDataFee2?: number, comProvider1?: 'GROUND_CONTROL' | 'MET_OCEAN' | 'GLOBALSTAR' | 'ORBCOMM' | 'IRIDIUM_JAPAN', comProvider2?: 'GROUND_CONTROL' | 'MET_OCEAN' | 'GLOBALSTAR' | 'ORBCOMM' | 'IRIDIUM_JAPAN', skipIridiumDeviceStatusCheck?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskId>>;
    public createNewAirtimeCostReport(comType: 'IRIDIUM' | 'GLOBALSTAR' | 'NB_IOT' | 'NO_COMMUNICATION' | 'GSM', year: number, month: 'JANUARY' | 'FEBRUARY' | 'MARCH' | 'APRIL' | 'MAY' | 'JUNE' | 'JULY' | 'AUGUST' | 'SEPTEMBER' | 'OCTOBER' | 'NOVEMBER' | 'DECEMBER', actualActivationFee1: number, actualMonthlyFee1: number, actualDataFee1: number, actualActivationFee2?: number, actualMonthlyFee2?: number, actualDataFee2?: number, comProvider1?: 'GROUND_CONTROL' | 'MET_OCEAN' | 'GLOBALSTAR' | 'ORBCOMM' | 'IRIDIUM_JAPAN', comProvider2?: 'GROUND_CONTROL' | 'MET_OCEAN' | 'GLOBALSTAR' | 'ORBCOMM' | 'IRIDIUM_JAPAN', skipIridiumDeviceStatusCheck?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskId>>;
    public createNewAirtimeCostReport(comType: 'IRIDIUM' | 'GLOBALSTAR' | 'NB_IOT' | 'NO_COMMUNICATION' | 'GSM', year: number, month: 'JANUARY' | 'FEBRUARY' | 'MARCH' | 'APRIL' | 'MAY' | 'JUNE' | 'JULY' | 'AUGUST' | 'SEPTEMBER' | 'OCTOBER' | 'NOVEMBER' | 'DECEMBER', actualActivationFee1: number, actualMonthlyFee1: number, actualDataFee1: number, actualActivationFee2?: number, actualMonthlyFee2?: number, actualDataFee2?: number, comProvider1?: 'GROUND_CONTROL' | 'MET_OCEAN' | 'GLOBALSTAR' | 'ORBCOMM' | 'IRIDIUM_JAPAN', comProvider2?: 'GROUND_CONTROL' | 'MET_OCEAN' | 'GLOBALSTAR' | 'ORBCOMM' | 'IRIDIUM_JAPAN', skipIridiumDeviceStatusCheck?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (comType === null || comType === undefined) {
            throw new Error('Required parameter comType was null or undefined when calling createNewAirtimeCostReport.');
        }
        if (year === null || year === undefined) {
            throw new Error('Required parameter year was null or undefined when calling createNewAirtimeCostReport.');
        }
        if (month === null || month === undefined) {
            throw new Error('Required parameter month was null or undefined when calling createNewAirtimeCostReport.');
        }
        if (actualActivationFee1 === null || actualActivationFee1 === undefined) {
            throw new Error('Required parameter actualActivationFee1 was null or undefined when calling createNewAirtimeCostReport.');
        }
        if (actualMonthlyFee1 === null || actualMonthlyFee1 === undefined) {
            throw new Error('Required parameter actualMonthlyFee1 was null or undefined when calling createNewAirtimeCostReport.');
        }
        if (actualDataFee1 === null || actualDataFee1 === undefined) {
            throw new Error('Required parameter actualDataFee1 was null or undefined when calling createNewAirtimeCostReport.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>comType, 'comType');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>year, 'year');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>month, 'month');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>actualActivationFee1, 'actualActivationFee1');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>actualMonthlyFee1, 'actualMonthlyFee1');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>actualDataFee1, 'actualDataFee1');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>actualActivationFee2, 'actualActivationFee2');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>actualMonthlyFee2, 'actualMonthlyFee2');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>actualDataFee2, 'actualDataFee2');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>comProvider1, 'comProvider1');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>comProvider2, 'comProvider2');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>skipIridiumDeviceStatusCheck, 'skipIridiumDeviceStatusCheck');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/airtime-cost-report/create`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TaskId>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param taskId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getConfirmAirtimeCostReportResult(taskId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AirtimeCostReportDto>;
    public getConfirmAirtimeCostReportResult(taskId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AirtimeCostReportDto>>;
    public getConfirmAirtimeCostReportResult(taskId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AirtimeCostReportDto>>;
    public getConfirmAirtimeCostReportResult(taskId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (taskId === null || taskId === undefined) {
            throw new Error('Required parameter taskId was null or undefined when calling getConfirmAirtimeCostReportResult.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/airtime-cost-report/get-confirm-result/${this.configuration.encodeParam({name: "taskId", value: taskId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AirtimeCostReportDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param taskId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCreateAirtimeCostReportResult(taskId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CreatedAirtimeCostReportDto>;
    public getCreateAirtimeCostReportResult(taskId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CreatedAirtimeCostReportDto>>;
    public getCreateAirtimeCostReportResult(taskId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CreatedAirtimeCostReportDto>>;
    public getCreateAirtimeCostReportResult(taskId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (taskId === null || taskId === undefined) {
            throw new Error('Required parameter taskId was null or undefined when calling getCreateAirtimeCostReportResult.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/airtime-cost-report/get-create-result/${this.configuration.encodeParam({name: "taskId", value: taskId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CreatedAirtimeCostReportDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param transactionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportByTransactionId(transactionId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AirtimeCostReportDto>;
    public getReportByTransactionId(transactionId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AirtimeCostReportDto>>;
    public getReportByTransactionId(transactionId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AirtimeCostReportDto>>;
    public getReportByTransactionId(transactionId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (transactionId === null || transactionId === undefined) {
            throw new Error('Required parameter transactionId was null or undefined when calling getReportByTransactionId.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>transactionId, 'transactionId');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/airtime-cost-report/by-transaction-id`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AirtimeCostReportDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReports(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<AirtimeCostReportDto>>;
    public getReports(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<AirtimeCostReportDto>>>;
    public getReports(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<AirtimeCostReportDto>>>;
    public getReports(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/airtime-cost-report`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<AirtimeCostReportDto>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
